// extracted by mini-css-extract-plugin
export default {"sectionHeading":"SectionHeading_sectionHeading__Dlyiu","white":"SectionHeading_white__a9u8O","tall":"SectionHeading_tall__+yEoA"};